// Central app configuration — update host here to change the API base URL across the app
export const host = "https://appconnect.jahajibd.com/";
